<template>
  <div class="xpress-error-section">
    <n-result
      status="error"
      title="PAGE NOT FOUND"
      description="Check page URL and try again."
    >
      <template #footer>
        <n-button
          ghost
          type="error"
          @click="$router.back()"
        >Back</n-button>
      </template>
    </n-result>
  </div>
</template>

<script>
import { NButton, NResult } from 'naive-ui'

export default {
  name: 'Error',
  components: {
    NResult,
    NButton
  }
}
</script>

<style lang="scss" scoped>
  div.xpress-error-section {
    width: 100vw;
    height: 80vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
